import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='email' component={Input} type='text' label={t('EmailBounce_Email')} />
						</Col>
						<Col sm={6}>
							<Field name='isHard' component={Input} componentClass='select' label={t('EmailBounce_IsHard')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('EmailBounce_Hard')}</option>
								<option value={false}>{t('EmailBounce_Soft')}</option>
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='dateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('EmailBounce_Date')} />
						</Col>
						<Col sm={6}>
							<Field name='dateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'emailBouncesFilter' })(withTranslation()(Filter));